import React, {useContext} from "react";
import { RadioButton } from 'primereact';
import {FormContext} from "./Form";
export function RadioButtonField(props) {
  const { name, label, value, ...otrasProps } = props;
  const { value: getValue, setValue } = useContext(FormContext);
  const styles = { display: "flex", alignItems: "center", gap: "0 5px" };

  return (
    <React.Fragment>
      <div style={styles}>
        <div className="radio-outer">
          <input
            type="radio"
            value={value}
            checked={value === getValue(name)}
            onChange={(event) => {
              setValue(name, event.target.value);
            }}
          />
        </div>
        <span>{label}</span>
      </div>
    </React.Fragment>
  );
}
